module.exports = __webpack_public_path__ + "doctor4.43dd038cd8ec67a7ef0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor4.png
// module id = 454
// module chunks = 1